import { post } from '../Services/http';
const rootRoute = '/api/gtm';
import { postConversionEvent, cookieAccepted } from './Conversion.action';

export const addToCartEvent = async (articleNumber, quantity = 1) => {
    try {
        const response = await post(`${rootRoute}/add-to-cart`, {
            articleNumber,
            quantity,
        });
        const event = await response.json();
        addToDataLayer(event);
        if (
            window.Cookiebot &&
            window.Cookiebot.consent &&
            window.Cookiebot.consent.marketing
        )
        await postConversionEvent(event, 'AddToCart');
    } catch (error) {
        console.error(error);
    }
};

export const removeFromCartEvent = async (articleNumber) => {
    try {
        const response = await post(`${rootRoute}/remove-from-cart`, {
            articleNumber,
        });
        const event = await response.json();
        addToDataLayer(event);
    } catch (error) {
        console.error(error);
    }
};

export const beginCheckoutEvent = async () => {
    try {
        const response = await post(`${rootRoute}/begin-checkout`);
        const event = await response.json();
        addToDataLayer(event);
        if (
            window.Cookiebot &&
            window.Cookiebot.consent &&
            window.Cookiebot.consent.marketing
        )
        await postConversionEvent(event, 'InitiateCheckout');
    } catch (error) {
        console.error(error);
    }
};

const addToDataLayer = (data) => {
    dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
};
